import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Paths } from "../routes/paths";
// import { UserHeader } from "../components/UserHeader";
import { ChildrenTable } from "../components/children/ChildrenTable";
import styles from "./css/AnalystAreaPage.module.css";
// import { useFeatures } from "../auth/useFeatures";
import { FEATURES } from "../routes/features";
import { FeatureButton } from "../components/FeatureButton";
import { useRefreshOnPurchase } from "../hooks/usePurchaseSuccess";
import { useRefreshAllFeatures } from "../redux/features";


export const AnalystPage = () => {
  const navigate = useNavigate();
const refreshFeatures = useRefreshAllFeatures();

  // שליפת analystId מ-Redux
  const analystCode = useSelector((state: any) => state.auth.user?.code);
  console.log('user from redux:', analystCode);
  console.log(analystCode);

  // ✅ אוטומטית רענן features כשיש רכישה מוצלחת
  useRefreshOnPurchase(() => {
    refreshFeatures();
  });


  return (
    <div className={styles.pageContainer}>
      {/* <UserHeader /> */}
      <main className={styles.mainContent}>
        {/* כפתור הוספת ילד – מוצג רק אם יש הרשאה */}
        {/* הודעת הסבר קבועה לעמוד */}
            <div className={styles.betaBanner}>
<p>
  בשלב זה נוצר לך ילד וירטואלי בשם <strong>"הילד המוכשר"</strong>
   בעזרתו תוכלי להתנסות ולהכיר את המערכת.<br />
  באפשרותך לבצע <strong>5</strong> ניתוחי התנהגות בעזרת ה־AI.<br />
  בהמשך תינתן אפשרות לרכישת חבילות שיאפשרו הוספת מטופלים,
  כניסת הורים,
  שימוש מורחב ב־AI ועוד.<br />
  נשמח לכל הערה, רעיון או הצעה 💡
</p>
</div><FeatureButton
  feature={FEATURES.ADD_CHILD}
  className={styles.addChildButton}
  onClick={() => navigate(`/${Paths.addChild}`)}
>
  הוספת ילד
</FeatureButton>

        {/* עטיפה לטבלה עם z-index נמוך יותר כדי שלא תכסֶה את הכפתור */}
        <div className={styles.tableContainer} style={{ position: "relative", zIndex: 1 }}>
          <ChildrenTable analystCode={analystCode} />
        </div>
      </main>
    </div>
  );
};
